module.exports = __webpack_public_path__ + "img/logo.ff01b101.png";